import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            position: 'relative',
            display: 'block',
        },
        customInputContainer: {
            position: 'relative',
            w: '100%',
            align: 'center',
        },
        customInput: {
            paddingRight: {
                base: 'small.base',
                sm: 'small.sm',
                md: 'small.md',
                lg: 'small.lg',
            },
            width: '100%',
            cursor: 'pointer',
            height: remCalc(40),
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            borderColor: 'border.secondary',
            _focus: {
                borderColor: 'border.secondary',
            },
        },
        defaultLabel: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        activeLabel: {
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            background: 'background.default',
            px: 1,
        },
        calendarIconContainer: {
            position: 'absolute',
            right: remCalc(10),
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: 'text.default',
        },
        '.react-datepicker-wrapper': {
            width: '100%',
        },
        '.react-datepicker': {
            textStyle: 'body-small',
            borderColor: 'text.date-picker-grey',
        },
        '.react-datepicker__header': {
            backgroundColor: 'background.light-dark',
            borderColor: 'text.date-picker-grey',
        },
        '.react-datepicker__triangle': {
            borderColor: 'text.date-picker-grey',
        },
        '.react-datepicker-popper': {
            zIndex: 10,
            marginLeft: {
                base: remCalc(30),
                sm: remCalc(30),
                md: 0,
                lg: 0,
            },
        },

        '.react-datepicker__navigation-icon::before': {
            borderTop: 'small',
            borderRight: 'small',
            borderBottom: 0,
            borderLeft: 0,
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        yearSelectContainer: {
            position: 'relative',
        },

        yearCombobox: {
            align: 'center',
            gap: remCalc(2),
            cursor: 'pointer',
            _focusVisible: {
                outline: `${remCalc(2)} solid`,
                outlineColor: 'black',
                outlineOffset: remCalc(2),
            },
        },

        yearText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
        },

        yearChevronContainer: {
            transition: 'transform 0.2s',
        },

        yearChevronIcon: {
            width: remCalc(12),
            height: remCalc(12),
        },

        yearListbox: {
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            mt: 1,
            maxH: `${remCalc(200)}`,
            overflowY: 'auto',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            bg: 'background.default',
            zIndex: 20,
            minW: remCalc(80),
        },

        yearOption: {
            px: remCalc(3),
            py: remCalc(2),
            cursor: 'pointer',
            _hover: {
                background: 'background.light',
            },
        },

        yearOptionSelected: {
            background: 'background.light-dark',
            fontWeight: 'semibold',
        },

        headerContainer: {
            width: '100%',
        },

        monthControllsContainer: {
            alignItems: 'center',
            justifyContent: 'center',
        },

        monthSelectButton: {
            _focusVisible: {
                outline: `${remCalc(2)} solid`,
                outlineColor: 'black',
                outlineOffset: `${remCalc(2)}`,
            },
        },

        monthSelectIcon: {
            width: remCalc(17),
            height: remCalc(17),
        },

        monthContainer: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
            textAlign: 'center',
        },

        yearsContainer: {
            justifyContent: 'center',
            py: 1,
        },
    },
    variants: {
        success: {
            customInput: {
                borderColor: 'border.success !important',
                _hover: {
                    borderColor: 'border.success !important',
                },
            },
        },
        error: {
            customInput: {
                borderColor: 'border.danger !important',
                _hover: {
                    borderColor: 'border.danger !important',
                },
            },
        },
        disabled: {
            customInput: {
                borderColor: 'border.disabled !important',
                pointerEvents: 'none',
                _hover: {
                    borderColor: 'border.disabled !important',
                    cursor: 'default !important',
                },
            },
        },
    },
}
